export default __webpack_public_path__ + "static/media/cz.51a0d6fd.svg";